<template>
  <div class="h-100 w-100 flex justify-between">
    <div @click="playTrack" class="pointer flex">
      <div class="fl track-image ma0 flex flex-row items-center justify-between mr3 relative hide-child">
        <span class="play absolute top-0 v-mid w-100 h-100 child bg-black-40 flex items-center justify-center pointer textColor">
          <div class="grow ba bw1 br-100 h2 w2 flex items-center justify-center textColor" @click.prevent="playTrack">
            <font-awesome-icon icon="play"/>
          </div>
        </span>
        <img class="h-100 w-100" :src="picture">
      </div>
      <div class="flex flex-column">
        <p @click="playTrack" class="text-width title fw6 fl pa1 pl3 ma0 text-ellipsis center-content textColor">{{ track.title }}</p>
        <router-link :to="{ name:'artist-info', params:{ id:track.id_artist }}" class="text-width textColor no-underline" append @click.native.stop>
          <p v-if="inHome === false && profileTracks === false" class="text-width artist fl h-100 pa1 pl3 ma0 text-ellipsis center-content textColor" :class="{'accent': inHome}">{{ track.artist.name }}</p>
          <p v-if="inHome === true && profileTracks === false" class="text-width artist fl h-100 pa1 pl3 ma0 text-ellipsis center-content textColor" :class="{'accent': inHome}">{{ track.name }}</p>
          <p v-if="inHome === false && profileTracks === true" class="text-width artist fl h-100 pa1 pl3 ma0 text-ellipsis center-content textColor" :class="{'accent': inHome}">{{ track.name }}</p>
        </router-link>
        <p v-if="inHome === false && profileTracks === false" class="text-width genre fl h-100 pa1 pl3 ma0 text-ellipsis center-content textColor">
          {{ track.genre.name }}</p>
        <p v-if="inHome === true && profileTracks === false" class="text-width genre fl h-100 pa1 pl3 ma0 text-ellipsis center-content textColor">
          {{ track.genre }}</p>
        <p v-if="inHome === false && profileTracks === true" class="text-width genre fl h-100 pa1 pl3 ma0 text-ellipsis center-content textColor">
          {{ track.music_type }}</p>
        <p class="text-width released fl h-100 pa1 pl3 ma0 center-content textColor">{{ this.trackTime }}</p>
      </div>
    </div>
    <div class="track-options fl h-100 ma0 iconColor">
      <track-options-button :inHome="inHome" :track="track" class="ma0 relative"/>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import TrackImage from './TrackImage'
  import TrackData from './TrackData'
  import TrackOptionsButton from '@/components/tracks/TrackOptionsButton.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import consts from '@/consts'

  export default {
    name: 'track-card',
    props: {
      track: {
        required: true
      },
      inHome: {
        default: false
      },
      profileTracks: {
        default: false
      }
    },
    data () {
      return {
        trackTime: null
      }
    },
    components: {
      TrackImage,
      TrackData,
      TrackOptionsButton,
      FontAwesomeIcon
    },
    computed: {
      ...mapGetters('player', [
        'currentTrack',
        'isPlaying'
      ]),
      ...mapGetters('track', [
        'loading'
      ]),
      picture () {
        // return consts.MEDIA_BASE_URL + ((this.track.path) ? this.track.path : '') + this.track.picture
        let trackPicture = ''
        if (!/\/uploads\/tracks\//.test(this.track.picture)) {
          trackPicture = '/uploads/tracks/' + this.track.picture
        } else { trackPicture = this.track.picture }
        return consts.MEDIA_BASE_URL + trackPicture
      }
    },
    methods: {
      ...mapActions('player', [
        'setPlaying',
        'changeTrack'
      ]),
      playTrack () {
        this.$emit('play')
      },
      trackTimeToMin () {
        let seg = this.track.seconds
        let min = 0
        this.trackTime = 0
        for (let i = 0; i < 60; i++) {
          if (seg >= 60) {
            min++
            seg -= 60
          } else if (seg < 60) {
            if (seg <= 9) {
              this.trackTime = (`${min}:0${seg}`)
              return this.trackTime
            } else {
              this.trackTime = (`${min}:${seg}`)
              return this.trackTime
            }
          }
        }
      }
    },
    mounted () {
      this.trackTimeToMin()
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .center-content {
    line-height: normal;
  }

  .title {
    height: 25px;
    padding: 0 0 0 5px;
  }

  .text-width {
    max-width: 17vw;
  }

  .artist {
    height: 25px;
    max-width: 50vw;
    padding: 0 0 0 5px;
  }

  .genre {
    height: 25px;
    padding: 0 0 0 5px;
    font-size: small;
  }

  .released {
    height: 25px;
    padding: 0 0 0 5px;
    font-size: x-small;
  }

  .track-options {
    width: 5%;
    float: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .track-image {
    max-width: 5rem;
    max-height: 5rem;
    min-width: 5rem;
    min-height: 5rem;
  }

  @media screen and (min-width: 1024px) {
    .text-width {
      max-width: 17vw;
    }
  }

  @media screen and (max-width: 479px) {
    .text-width {
      max-width: 45vw;
    }
    .child {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tracks/TrackCard.vue